import React, { useRef, useState } from 'react';
import { Input, Button, InputRef } from 'antd';
import { StyledSearch } from '../styled';
import { SearchOutlined } from '@ant-design/icons';

function Search({ onSearch, searchText }) {
  const inputRef = useRef<InputRef>(null);
  const [collapsed, setCollapsed] = useState(true);

  const expand = () => {
    setCollapsed(false);
    // next render mounts the input
    setTimeout(() => {
      inputRef.current!.focus({
        cursor: 'start',
      });
    });
  }

  const handleSearch = (value) => {
    onSearch(value.toLowerCase());
  }

  const handleBlur = () => {
    if(searchText === '') {
      setCollapsed(true);
    }
  }

  return (
    <StyledSearch onClick={(event) => event.stopPropagation()}>
      {collapsed ?
        <Button icon={<SearchOutlined />} type="text" onClick={expand} />
        : <Input.Search
          ref={inputRef}
          placeholder="Search"
          allowClear
          onSearch={handleSearch}
          style={{ width: 200 }}
          onBlur={handleBlur}
        />
      }
    </StyledSearch>
  );
}

export default Search;
